
import './ShowOnLineStatus.css';
import { FiAlertTriangle } from 'react-icons/fi';

const ShowOnlineStatus = ({refresh, setRefresh}) => {

 
    return (
      <div className='NetworkStatusMainContainer'>
        <div id='ShowOnlineStatusMainContainer'>
          <p>Brak połączenia z internetem</p>
          <p>Funkcjonalność serwisu została ograniczona</p>
          <FiAlertTriangle className='ConnectionAlertIcon'/>
        </div>
      </div> 
       
    )
}

export default ShowOnlineStatus;
